/**
 * Parse PALLET catalogue Props → packing dims.
 * Props: { width, length, emptyWeight, palletHeight } (length maps to depth/largo;
 * palletHeight is the empty tarima/skid height in cm).
 * @param {object|string|null|undefined} props
 * @returns {{ palletWidth: number, palletDepth: number, palletEmptyWeight: number, palletHeight: number }|null}
 */
export function palletDimsFromProps(props) {
  let parsed = props;
  if (typeof props === "string") {
    try {
      parsed = JSON.parse(props);
    } catch {
      return null;
    }
  }
  if (!parsed || typeof parsed !== "object") return null;

  const width = Number(parsed.width ?? parsed.Width);
  const length = Number(
    parsed.length ?? parsed.Length ?? parsed.depth ?? parsed.Depth
  );
  const emptyWeight = Number(
    parsed.emptyWeight ?? parsed.EmptyWeight ?? parsed.empty_weight ?? 0
  );
  const palletHeight = Number(
    parsed.palletHeight ?? parsed.PalletHeight ?? 0
  );

  if (![width, length].every((n) => Number.isFinite(n) && n > 0)) {
    return null;
  }

  return {
    palletWidth: width,
    palletDepth: length,
    palletEmptyWeight: Number.isFinite(emptyWeight) ? emptyWeight : 0,
    palletHeight: Number.isFinite(palletHeight) && palletHeight > 0 ? palletHeight : 0,
  };
}
